module.exports = __webpack_public_path__ + "static/media/ky.bb672e36.webp";